import * as CONST from 'actions/action_constants';

export const requestAnalytics = (filters, account) => ({
  type: CONST.ANALYTICS_REQUEST,
  filters,
  account,
});
